import { IAppState } from '../../common/state';
import { IBuilder } from '../../types/newbuildingHeader';
import { getBuilders } from './getBuilders';

export function getBuilder(state: IAppState): IBuilder | null {
  const builders = getBuilders(state);

  if (builders) {
    return builders[0];
  }

  return null;
}
